<template>
  <div>
    <div class="my-3">
      <p v-if="grapesJSInstance !== null">
        The list below shows the data elements that can be brought in to your email campaign to personalize for each email recipient. Clicking Select will bring the data string (begins with #) on the line you clicked select. The email campaign will show (for example) #FirstName#. To see the actual name, review the previews in Inbox Forecaster Report, and/or send an email to the test seed list.
      </p>
      <p v-else>
        The list below shows the data elements that can be brought in to your email campaign to personalize for each email recipient. Clicking Copy the data string (begins with #) will be added to your clipboard. The email campaign will show (for example) #FirstName#. To see the actual name, review the previews in Inbox Forecaster Report, and/or send an email to the test seed list.
      </p>
    </div>
    <div
      v-if="customLinks.length"
      class="my-3"
    >
      <ejs-grid
        :data-source="customLinks"
        :toolbar="toolbarOptions"
        :allow-paging="true"
        :allow-filtering="true"
        :page-settings="pageSettings"
        :filter-settings="filterOptions"
        :allow-sorting="true"
        clip-mode="EllipsisWithTooltip"
      >
        <e-columns>
          <e-column
            field=" "
            header-text=""
            width="30"
            :template="selectTemplate"
            :allow-filtering="false"
            :allow-sorting="false"
          />
          <e-column
            field="name"
            header-text="Name"
            width="80"
          />
          <e-column
            field="value"
            header-text="Value"
            width="130"
            :allow-filtering="false"
            :allow-sorting="false"
          />
          <e-column
            field="description"
            header-text=""
            width="200"
            :allow-filtering="false"
            :allow-sorting="false"
          />
        </e-columns>
      </ejs-grid>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import { GridPlugin, Toolbar, Search, Page, Sort, Filter } from '@syncfusion/ej2-vue-grids'
import { createElement } from '@syncfusion/ej2-base'
import { TextBox } from '@syncfusion/ej2-inputs'
import GridSelect from './GridSelect'
import { MultiSelect, CheckBoxSelection } from '@syncfusion/ej2-dropdowns'

Vue.use(GridPlugin)
MultiSelect.Inject(CheckBoxSelection)

export default {
  provide () {
    return {
      grid: [Toolbar, Search, Filter, Sort, Page],
      onClick: this.onSelect
    }
  },
  data () {
    return {
      pageSettings: { pageCount: 5, pageSize: 10, pageSizes: ['10', '25', '50', '100'] },
      filterOptions: {
        type: 'Menu',
        mode: 'OnEnter',
        operators: {
          stringOperator: [
            { value: 'startsWith', text: 'Starts With' },
            { value: 'endsWith', text: 'Ends With' },
            { value: 'contains', text: 'Contains' },
            { value: 'equal', text: 'Equal' }
          ]
        }
      },
      filter: {
        type: 'CheckBox'
      },
      toolbarOptions: ['Search'],
      customFilter: {
        ui: {
          create: (args) => {
            const flValInput = createElement('input', {
              className: 'flm-input'
            })
            args.target.appendChild(flValInput)
            this.dropInstance = new TextBox({
              placeholder: 'Enter the value'
            })
            this.dropInstance.appendTo(flValInput)
            this.$helpers.setFilterId(this.dropInstance.element)
          },
          write: (args) => {
            if (args.filteredValue) {
              this.dropInstance.value = args.filteredValue
            }
          },
          read: (args) => {
            args.fltrObj.filterByColumn(
              args.column.field,
              args.operator,
              this.dropInstance.value,
              false
            )
          }
        }
      },
      selectTemplate () {
        return {
          template: {
            extends: GridSelect
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      grapesJSInstance: 'getGrapesJSInstance',
      dynamicContent: 'getDynamicContent',
      customLinks: 'getCustomLinks'
    })
  },
  mounted () {
    const userEmail = this.$route.query.userEmail ? atob(this.$route.query.userEmail) : ''
    const templateId = this.$route.params.id
    this.getCustomLinks({ templateId, userEmail })
  },
  methods: {
    ...mapActions([
      'getCustomLinks'
    ]),
    onSelect (link) {
      // if the grapeJS Instance is null, then copying the text for drag n drop
      if (this.grapesJSInstance === null) {
        this.legacyCopyToClipboard(link)
        this.dynamicContent.modalRef.closeDialog()
      } else {
        this.grapesJSInstance.InsertMoreOptData({
          action: 'InsertMoreOptData',
          type: 'link',
          value: link,
          moreoption: true
        })
        this.dynamicContent.modalRef.closeDialog()
      }
    },
    legacyCopyToClipboard (text) {
      const textArea = document.createElement('textarea')
      textArea.value = text
      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()
      try {
        document.execCommand('copy')
      } catch (err) {
        console.error('Unable to copy to clipboard', err)
      }
      document.body.removeChild(textArea)
    },
    getSectionFilter () {
      return this.getArrayFilter('Select a section', 'sections')
    },
    getArrayFilter (placeHolder, propertyName) {
      return {
        ui: {
          create: (args) => {
            const flValInput = createElement('input', {
              className: 'flm-input'
            })
            args.target.appendChild(flValInput)
            if (args.target.parentElement.children) {
              args.target.parentElement.children[0].style.display = 'none'
              args.target.parentElement.children[1].style.paddingTop = '0px'
            }
            this.dropInstance = new MultiSelect({
              dataSource: this[propertyName],
              fields: {
                text: 'name',
                value: 'id'
              },
              placeholder: placeHolder,
              popupHeight: '200px',
              mode: 'CheckBox'
            })
            this.dropInstance.value = this.dropInstance.value || []
            this.dropInstance.appendTo(flValInput)
          },
          write: (args) => {
            let arr = []
            if (
              args.parent.filterModule.actualPredicate
                .tags !== undefined
            ) {
              arr = args.parent.filterModule.actualPredicate.tags.map(
                (element) => element.value
              )
            }
            this.dropInstance.value = Array.isArray(args.filteredValue)
              ? args.filteredValue
              : arr
          },
          read: (args) => {
            args.fltrObj.filterSettings.columns = args.fltrObj.filterSettings.columns.filter(
              (x) => {
                return x.field !== args.column.field
              }
            )
            args.fltrObj.filterByColumn(
              args.column.field,
              args.operator,
              this.dropInstance.value
            )
          }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
